import {AnyLicence, PractitionerLicence} from '..';

export const isPractitionerLicence = (licence: AnyLicence): licence is PractitionerLicence => {
  const validLicenceIds = ['practitionerLicence3Year', 'practitionerLicence7Day', 'traineeLicence'];
  return validLicenceIds.includes((licence as PractitionerLicence).licence_type_id);
}